import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    // Bind the method to preserve 'this' context
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    
    // Add event listener to the document for keyboard shortcuts
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    // Clean up event listener when controller is disconnected
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  handleKeydown(event) {
    // Check if Ctrl+Enter (or Cmd+Enter on Mac) is pressed
    if (event.key === "Enter" && (event.ctrlKey || event.metaKey)) {
      // Find the form within this controller's scope
      const form = this.formTarget
      
      if (form) {
        // Check if we're focused on a textarea or input within the form
        const activeElement = document.activeElement
        const isInForm = form.contains(activeElement)
        
        if (isInForm) {
          // Prevent default behavior
          event.preventDefault()
          
          // Submit the form
          form.requestSubmit()
          
          // Optional: Show visual feedback
          this.showSubmitFeedback()
        }
      }
    }
  }

  showSubmitFeedback() {
    // Find the submit button and briefly highlight it
    const submitButton = this.formTarget.querySelector('input[type="submit"], button[type="submit"]')
    
    if (submitButton) {
      // Add a temporary class for visual feedback
      submitButton.classList.add('ring-2', 'ring-blue-400')
      
      // Remove the class after a short delay
      setTimeout(() => {
        submitButton.classList.remove('ring-2', 'ring-blue-400')
      }, 200)
    }
  }
} 